import {TopicList} from '../../../components/Topics/TopicList'

const AllTopicsPage = () => {
  return <TopicList />
}

export {AllTopicsPage}
